export const profileTableStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
};

export const tableCellStyle = {
  paddingBottom: '.7rem',
  paddingTop: '.7rem',
};

export const adAreaStyle = {
  display: 'grid',
  gridTemplateColumns: 'auto auto auto auto',
  gridGap: '1.2rem',
  justifyContent: 'center',
  margin: '1rem',
};

export const boardStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const paginationStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const dashCardStyle = { height: '150px' };

export const purchasedListContainerStyle = { display: 'flex', flexDirection: 'column' };

export const purchasedListTableStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '1rem'
};